const colors = {
  // Backgrounds
  bgPrimary: "#0B1120", // page background
  bgCard: "#141E30", // cards, sections
  bgBorder: "#1E2D42", // borders, dividers

  // Brand accents
  accentBlue: "#185FA5", // primary CTA buttons, active states
  accentCyan: "#00C6FF", // highlights, links, hover glows
  accentOrange: "#FF6B35", // discount badges, sale tags, warnings

  // Status
  statusGreen: "#22C55E", // success, online indicator
  statusRed: "#E24B4A", // error states

  // Typography
  textPrimary: "#E8F0FE", // headings, main text
  textMuted: "#7B8DAA", // body, secondary text
  textHint: "#3D5068", // placeholders, tertiary

  // Gradients (use as CSS strings)
  gradientHero: "linear-gradient(135deg, #0B1120 0%, #141E30 100%)",
  gradientCard: "linear-gradient(180deg, #141E30 0%, #0F1928 100%)",
  gradientCyan: "linear-gradient(90deg, #185FA5 0%, #00C6FF 100%)",
};

export default colors;
